import { userInfoStore, BetResponseCode, notificationStore } from '@pascal/pascal-core';

import { doBetStore } from '../store/doBetStore';
import { reBetStore } from '../store/reBetStore';

export const balanceChecker = () => {
  const userAllBetAmount = reBetStore.reBetInfo.reduce((acc, curr) => acc + curr.betAmount, 0);
  if (userAllBetAmount > userInfoStore.balance && !doBetStore.pigs[0].isNextRoundBet) {
    const updatedPigsData = reBetStore.reBetInfo.map((pig) => ({
      ...pig,
      betAmount: 0,
      isNextRoundBet: false,
    }));

    doBetStore.setPigsData(updatedPigsData);

    notificationStore.setNotificationType(BetResponseCode.InsufficientFunds);
    setTimeout(() => notificationStore.setNotificationType(null), 1000);
    reBetStore.setReBetInfo([]);
  }
};
